import { OTP } from "../Reducers/otpReducer";
import {addNewPartner, createOtp, createPartnerV2, verifyOtp} from "../Util/queries";
import verifyEmailAndPass from "./loginAction";

export const SIGN_UP_STATE = "SIGN_UP_STATE";

const newUserSignUp = (companyName, phoneNumber, emailAddress,
                       address, contactPerson,
                       contactPersonTitle, billingAddress,
                       password, countryCode) => async dispatch => {
    try {
        let response = await addNewPartner({
            companyName: companyName, address: address,
            phoneNumber: phoneNumber, email: emailAddress, contactPerson: contactPerson,
            titleOfContactPerson: contactPersonTitle, billingAddress: billingAddress,
            partnerType: "AFFILIATE", password: password, countryCode: countryCode
        })

        if (response.status === 200 || response.status === 201) {
            dispatch(verifyEmailAndPass(emailAddress, password))
        } else {
            dispatch({
                type: SIGN_UP_STATE,
                payload: false
            })
        }
    } catch (e) {
        dispatch({
            type: SIGN_UP_STATE,
            payload: false
        })
    }
}

const fixPhone = (phone) => {
    if (phone?.[0] === '+') return phone;
    else return '+' + phone;
}

export const generateOtp = (phoneNumber) => async dispatch => {
    dispatch({
        type: OTP,
        payload: {phoneNumber: phoneNumber, generated: null, verified: false, genError: false, verifError: false}
    })
    try {
        let response = await createOtp({phoneNumber: fixPhone(phoneNumber)});
        if (response.data.success) {
            dispatch({
                type: OTP,
                payload: {phoneNumber: phoneNumber, generated: true, attemptsLeft: 3, verified: null, genError: false, verifError: false}
            })
        } else {
            dispatch({
                type: OTP,
                payload: {phoneNumber: phoneNumber, generated: false, genError: false, verifError: false}
            })
        }

    } catch (e) {
        dispatch({
            type: OTP,
            payload: {phoneNumber: phoneNumber, generated: null, genError: true}
        })
    }
}

export const verifyOtpAndCreatePartner = (data, otp) => async dispatch => {
    const payload = {
        contactPerson: data.firstName + " " + data.lastName,
        email: data.email,
        phoneNumber: fixPhone(data.phoneNumber),
        countryCode: data.country,
        password: data.password,
        otp: otp,
    }
    dispatch({
        type: OTP,
        payload: {phoneNumber: data.phoneNumber, verified: null, genError: false, verifError: false}
    })
    try {
        let response = await verifyOtp({phoneNumber: payload.phoneNumber, otp: otp});
        if (response.data.success) {
            dispatch({
                type: OTP,
                payload: {phoneNumber: data.phoneNumber, verified: true, attemptsLeft: 0, genError: false, verifError: false}
            });
        } else {
            dispatch({
                type: OTP,
                payload: {phoneNumber: data.phoneNumber, verified: false, attemptsLeft: response.data.remainingAttempts, genError: false, 
                    verifError: response.data.remainingAttempts === 0}
            });
            return;
        }
    } catch (e) {
        dispatch({
            type: OTP,
            payload: {phoneNumber: data.phoneNumber, verified: false, verifError: true}
        })
        return;
    }
    
    dispatch({
        type: SIGN_UP_STATE,
        payload: null
    })
    try {
        let response = await createPartnerV2(payload)

        if (response.status === 200 || response.status === 201) {
            dispatch(verifyEmailAndPass(payload.email, payload.password))
        } else {
            dispatch({
                type: SIGN_UP_STATE,
                payload: false
            })
        }
    } catch (e) {
        dispatch({
            type: SIGN_UP_STATE,
            payload: false
        })
    }
}

export default newUserSignUp;
